import {
    VerificationTransactionDetailsPolicyDecision,
    FormattedVerificationTransactionDetailsPolicyDecision
} from "@idw-types/data/verification-transaction-details";
import { PolicyDecisionTypes } from "@enums/policy-decision-types";

export const formatVerificationTransactionDetailsPolicyDecisions = (
    policyDecisions: Array<VerificationTransactionDetailsPolicyDecision>
): Array<FormattedVerificationTransactionDetailsPolicyDecision> => {
    return policyDecisions.map(pd => formatVerificationTransactionDetailsPolicyDecision(pd));
};

export const formatVerificationTransactionDetailsPolicyDecision = (
    policyDecision: VerificationTransactionDetailsPolicyDecision
): FormattedVerificationTransactionDetailsPolicyDecision => {
    let date = null;
    if (policyDecision.date) {
        date = new Date(parseInt(policyDecision.date));
    }

    let decision = policyDecision.decision;
    if (decision === PolicyDecisionTypes.OBLIGATION && policyDecision.apiKey && policyDecision.obligationAPIKey && policyDecision.apiKey === policyDecision.obligationAPIKey) {
        decision = PolicyDecisionTypes.RETRY;
    }

    return {
        apiKey: policyDecision.apiKey,
        attempt: policyDecision.attempt,
        date: date,
        decision: decision,
        decisionDetail: policyDecision.decisionDetail,
        id: policyDecision.id,
        obligationAPIKey: policyDecision.obligationAPIKey,
        obligationRPServiceName: policyDecision.obligationRPServiceName,
        policyDecisionConditionResults: policyDecision.policyDecisionConditionResults,
        policyName: policyDecision.policyName,
        rpServiceName: policyDecision.rpServiceName
    };
};